import React from 'react';

import cancelIcon from "../../../img/icon/icon-cancel.svg";

const AttendanceFail = ({varPopupAttendanceFail,setPopupAttendanceFail,varFailMessage,onCloseInitHandler}) => {

  return (
    <div className="layer-pop login-pop02" style={varPopupAttendanceFail?{display:"block",height:"250px"}:{display:"none"}}>
      <div className="layer-con">
        <div className="layer-hd">
          <div className="tit">출석 인증 실패</div>
          <div className="close-layer" onClick={()=>setPopupAttendanceFail(false)}><img src={cancelIcon} alt=""/></div>
          </div>
        <div className="info">
          <div className="info">{varFailMessage} <br/>센터 선생님께 문의해주세요.</div>
          <div className="form-contoller bt-btn">
            <button className="form-contoller-btn btn-yes" onClick={(e)=>onCloseInitHandler(e,1)}>확인</button>
          </div>
        </div>
      </div>
    </div>
  )
}
export default AttendanceFail;